import { Component, inject, OnInit, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { MiniFooterComponent } from './shared/components/mini-footer/mini-footer.component';
import {
  LangType
} from '@shared/organism.header';
import { filter, take } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { isPlatformBrowser } from '@angular/common';
import { WecLoadingComponent } from './shared/components/wec-loading/wec-loading.component';
import { GetHeaderLogoUsecase } from '@usecase/header-logo/header-logo.usecase';
import { ITEM } from '@utils/constants';
import { HeaderLogoDto } from '@data/data/models/header-logo.dto';
import { MiniHeaderComponent } from '@shared/component.mini-header';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, MiniFooterComponent, WecLoadingComponent, MiniHeaderComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {

  headerLogo: HeaderLogoDto = {
    logo: '',
    path: ''
  };

  private readonly router = inject(Router);
  private readonly activatedRoute = inject(ActivatedRoute);
  private readonly translateService = inject(TranslateService);
  private readonly getHeaderLogoUsecase = inject(GetHeaderLogoUsecase);
  private readonly platformId = inject(PLATFORM_ID);

  ngOnInit(): void {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        if (isPlatformBrowser(this.platformId)) {
          const currentUrl = globalThis.location.pathname;
          this.getHeaderLogo(currentUrl);
        }
      });
  }

  getHeaderLogo(currentUrl: string) {
    this.getHeaderLogoUsecase.execute(currentUrl).pipe(take(ITEM.SINGLE_EMISSION)).subscribe({
      next: (resp: HeaderLogoDto) => {
        this.headerLogo = resp;
      }
    });
  }

  /**
   *
   * Query Params Lang Obvserver
   */
  onGetDefaultLang() {
    this.activatedRoute.queryParams.subscribe((params) => {
      if (params['lang']) {
        return this.translateService.use(params['lang']);
      }

      if (isPlatformBrowser(this.platformId)) {
        const url = globalThis.location.pathname;
        return this.router.navigate([url], {
          queryParams: {
            lang: String(localStorage.getItem('lang') ?? 'ID').toLowerCase()
          }
        });
      } else {
        return;
      }
    });
  }

  onLanguageChange(lang: LangType) {
    this.translateService.use(lang.toLowerCase());
  }

}
